<template>
  <span v-if="label" class="legacy-entry-direction" :class="bullish ? 'is-bullish' : 'is-bearish'" :title="label" :aria-label="label" role="img">
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">
      <path :d="bullish ? 'M8 13V3M4 7l4-4 4 4' : 'M8 3v10M4 9l4 4 4-4'" />
    </svg>
  </span>
</template>

<script>
import { legacyStockDirectionLabel } from '../models/legacyStockMembership';
export default {
  name: 'LegacyEntryDirection',
  props: { direction: { type: [Number, String], default: null } },
  computed: {
    bullish() { return this.direction === 1 || this.direction === '1'; },
    label() { return legacyStockDirectionLabel(this.direction); }
  }
};
</script>

<style scoped>
.legacy-entry-direction { display: inline-flex; flex: 0 0 auto; line-height: 14px; }
.legacy-entry-direction svg { fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.is-bullish svg { stroke: #29985d; }
.is-bearish svg { stroke: #c14b53; }
</style>
